// React
import { useEffect, useState } from "react";
// Recoil
import { useRecoilState, useSetRecoilState } from "recoil";
import { isAdminMode, requestState } from "../../atom/menu";
// Components
import ControllerOrder from "../../components/menu/common/ControllerOrder";
// Assets
import { languageList } from "../../assets/languageList";
import { RequestType } from "../../assets/Type";

type ButtonPropsTypes = {
  action: () => void;
};

function IntroOrdered(props: ButtonPropsTypes) {
  // 직원 요청 화면

  const reqList = [
    "물컵",
    "숟가락",
    "젓가락",
    "물티슈",
    "냅킨",
    "물",
    "반찬리필",
    "앞치마",
  ];
  // Recoil State
  const setIsAdminPopup = useSetRecoilState(isAdminMode);
  const [requestList, setRequestList] = useRecoilState(requestState);
  // useState
  const [request, setRequest] = useState<RequestType[] | []>([]);
  const [viewState, setViewState] = useState<number>(0);
  const [isSuccessCall, setIsSuccessCall] = useState<boolean>(false);

  // Function
  const tripleClick = () => {
    // **기능정의**
    // 로고 3번 클릭 시, 관리자 페이지 이동 (1초안에 3번 클릭)
    setIsAdminPopup(true);
  };

  useEffect(() => {
    const logoEle = document.getElementById("triple");
    if (logoEle) {
      // let clicks = 0;
      // let timer,
      //   timeout = 1000;
      logoEle.addEventListener("click", function (e) {
        tripleClick();
        // clicks++;
        // timer = setTimeout(function () {
        //   if (clicks == 3 || clicks == 4) tripleClick();
        //   clicks = 0;
        // }, timeout);
      });
    }
  }, []);

  const selectRequestService = (service: string) => {
    if (request) {
      const prev = [...request];
      prev.unshift({
        name: service,
        ea: 1,
      });
      setRequest(prev);
    } else {
      setRequest([
        {
          name: service,
          ea: 1,
        },
      ]);
    }
  };
  const requestService = () => {
    setIsSuccessCall(true);
    setTimeout(() => {
      setIsSuccessCall(false);
      props.action();
    }, 2000);
    if (requestList) {
      const prev = [...requestList];
      prev.unshift({
        request: [...request],
        time: `${
          new Date().getHours() < 9
            ? "0" + new Date().getHours()
            : new Date().getHours()
        }:${
          new Date().getMinutes() < 9
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes()
        }:${
          new Date().getSeconds() < 9
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds()
        }`,
      });
      setRequestList(prev);
    } else {
      setRequestList([
        {
          request: [...request],
          time: `${
            new Date().getHours() < 9
              ? "0" + new Date().getHours()
              : new Date().getHours()
          }:${
            new Date().getMinutes() < 9
              ? "0" + new Date().getMinutes()
              : new Date().getMinutes()
          }:${
            new Date().getSeconds() < 9
              ? "0" + new Date().getSeconds()
              : new Date().getSeconds()
          }`,
        },
      ]);
    }
  };

  const deleteOrder = (requestName: string) => {
    const prev = [...request];
    if (prev.find((v) => v.name === requestName)!.ea > 1) {
      prev.splice(
        prev.findIndex((v) => v.name === requestName),
        1,
        {
          name: requestName,
          ea: prev!.find((v) => v.name === requestName)!.ea - 1,
        }
      );
    } else {
      prev.splice(
        prev.findIndex((v) => v.name === requestName),
        1
      );
    }
    setRequest([...prev]);
  };
  const addOrder = (requestName: string) => {
    const prev = [...request];
    if (prev.find((v) => v.name === requestName)) {
      prev.splice(
        prev.findIndex((v) => v.name === requestName),
        1,
        {
          name: requestName,
          ea: prev.find((v) => v.name === requestName)!.ea + 1,
        }
      );
    } else {
      prev.unshift({
        name: requestName,
        ea: 1,
      });
    }
    setRequest([...prev]);
  };
  const closePopup = () => {
    setViewState(0);
  };
  const resetPopup = () => {
    props.action();
    setViewState(0);
  };

  const callServer = () => {
    setViewState(1);
  };

  return (
    <>
      <div className='menu-popup-bg'>
        <div className='menu-header-wrap'>
          <img
            id='triple'
            className='logo-img'
            src={"/assets/images/menu/logo.png"}
            alt='vd company logo'
          />
        </div>

        <div className='flex col ' style={{ height: "calc(100% - 80px)" }}>
          <div
            className='menu-intro-wrap'
            style={{ gap: 38, maxWidth: 1055, margin: "0 auto", padding: 0 }}
          >
            <div className='TO-title-2 text-color-gray'>
              필요하신 서비스를 선택 후 호출해 주세요
            </div>
            <div className='service-gird-wrap' style={{ marginBottom: 400 }}>
              {reqList.map((v, i) => {
                return request?.find((val) => val.name === v) ? (
                  // 이미 요청한 서비스
                  <div className='service-btn selected-lang pointer'>
                    <div className='TO-title-2' style={{ height: "100px" }}>
                      {v}
                    </div>
                    {/* Controller */}
                    <div className='controller'>
                      <div
                        className='flex row center'
                        style={{ gap: 8, width: "fit-content", marginTop: 8 }}
                      >
                        {/* 플러스 */}
                        <div
                          className='control-btn-small'
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteOrder(v);
                          }}
                        >
                          {request?.find((val) => val.name === v)?.ea === 0 ? (
                            <img
                              src={`/assets/images/menu/minus.svg`}
                              alt={"minuse button"}
                            />
                          ) : (
                            <img
                              src={`/assets/images/menu/minus2.svg`}
                              alt={"minuse button"}
                            />
                          )}
                        </div>

                        <div className='control-count-small TO-price-2 text-color-black'>
                          {request?.find((val) => val.name === v)?.ea}
                        </div>

                        {/* 마이너스 */}
                        <div
                          className='control-btn-small'
                          onClick={(e) => {
                            e.stopPropagation();
                            addOrder(v);
                          }}
                        >
                          <img
                            src={`/assets/images/menu/plus.svg`}
                            alt={"plus button"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // 처음 요청하는 서비스
                  <div
                    className='service-btn pointer'
                    onClick={() => {
                      selectRequestService(v);
                    }}
                  >
                    <div className='TO-title-2' style={{ height: "100px" }}>
                      {v}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className='menu-intro-button'>
            <div className='botton-bg-gradation' style={{ top: "-32px" }}></div>
            <div
              className='basic-btn white TO-button-1 pointer'
              onClick={() => {
                props.action();
              }}
            >
              닫기
            </div>
            <div
              className='basic-btn TO-button-1 red pointer'
              onClick={() => {
                callServer();
              }}
            >
              직원만 호출
            </div>
            {request && request.length > 0 ? (
              <div
                className='basic-btn TO-button-1 pointer'
                style={{ backgroundColor: "#D71718" }}
                onClick={() => {
                  requestService();
                }}
              >
                호출하기
              </div>
            ) : (
              <div className='basic-btn TO-button-1 red-disabled'>호출하기</div>
            )}
          </div>
        </div>
      </div>
      {viewState === 1 && <PopupCallServer action={resetPopup} />}
      {viewState === 3 && <PopupLanguageList action={closePopup} />}
      {isSuccessCall && (
        <div className='menu-popup-bg'>
          <div
            className='flex col center'
            style={{ padding: "142px 0", gap: 16 }}
          >
            <div
              className='TO-title-1'
              style={{ width: 895, textAlign: "center", color: "#323232" }}
            >
              호출이 완료되었습니다
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default IntroOrdered;

function PopupCallServer(props: ButtonPropsTypes) {
  // 직원 호출 팝업

  // Recoil State
  const [requestList, setRequestList] = useRecoilState(requestState);
  // useState
  const [isCall, setIsCall] = useState<boolean>(true);
  const [isSuccessCall, setIsSuccessCall] = useState<boolean>(false);

  // Function
  const requestService = (service: string) => {
    if (requestList) {
      const prev = [...requestList];
      prev.unshift({
        request: [
          {
            name: "직원요청",
            ea: 1,
          },
        ],
        time: `${
          new Date().getHours() < 9
            ? "0" + new Date().getHours()
            : new Date().getHours()
        }:${
          new Date().getMinutes() < 9
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes()
        }:${
          new Date().getSeconds() < 9
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds()
        }`,
      });
      setRequestList(prev);
    } else {
      setRequestList([
        {
          request: [
            {
              name: "직원요청",
              ea: 1,
            },
          ],
          time: `${
            new Date().getHours() < 9
              ? "0" + new Date().getHours()
              : new Date().getHours()
          }:${
            new Date().getMinutes() < 9
              ? "0" + new Date().getMinutes()
              : new Date().getMinutes()
          }:${
            new Date().getSeconds() < 9
              ? "0" + new Date().getSeconds()
              : new Date().getSeconds()
          }`,
        },
      ]);
    }
  };

  return (
    <div className='menu-popup-bg'>
      {isCall && (
        <div
          className='flex col center'
          style={{ padding: "142px 0", gap: 16 }}
        >
          <div className='TO02-title-1'>
            직원을 호출하시기 전에 확인해 주세요
          </div>
          <div
            className='TO-title-1'
            style={{ width: 895, textAlign: "center", color: "#323232" }}
          >
            직원을 부르시기 전 필요하신 서비스를 선택해주시면 더욱 원활한 서비스
            진행이 가능합니다.
          </div>
          <div className='menu-intro-button' style={{ marginTop: 64 }}>
            <div
              className='basic-btn white TO-button-1 pointer'
              style={{ maxWidth: 324 }}
              onClick={() => {
                props.action();
              }}
            >
              취소
            </div>
            <div
              className='basic-btn TO-button-1 pointer'
              style={{ width: 324 }}
              onClick={() => {
                setIsCall(false);
                requestService("직원요청");
                setIsSuccessCall(true);
                setTimeout(() => {
                  setIsCall(true);
                  setIsSuccessCall(false);
                  props.action();
                }, 2000);
              }}
            >
              직원만 호출
            </div>
          </div>
        </div>
      )}
      {isSuccessCall && (
        <div
          className='flex col center'
          style={{ padding: "142px 0", gap: 16 }}
        >
          <div
            className='TO-title-1'
            style={{ width: 895, textAlign: "center", color: "#323232" }}
          >
            호출이 완료되었습니다
          </div>
        </div>
      )}
    </div>
  );
}
function PopupLanguageList(props: ButtonPropsTypes) {
  const [selectLang, setSelectLang] = useState<string>("한국어");
  const changeLang = () => {
    props.action();
  };

  return (
    <div className='menu-popup-bg'>
      <div className='menu-popup-wrap'>
        <div className='menu-header-wrap'>
          <img
            id='triple'
            className='logo-img'
            src={"/assets/images/menu/logo.png"}
            alt='vd company logo'
          />
        </div>
        <div className='flex col' style={{ height: "calc(100% - 100px)" }}>
          <div className='menu-intro-wrap' style={{ gap: 40 }}>
            <div className='TO-title-2 text-color-gray'>
              Please select the language you would like to switch to
            </div>
            <div
              className='flex row wrap center'
              style={{ gap: 16, marginBottom: 500 }}
            >
              {languageList.map((v) => {
                return v.text === selectLang ? (
                  <div className='service-lang-btn TO-button-1 selected-lang'>
                    {v.text}
                  </div>
                ) : (
                  <div className='service-lang-btn TO-button-1'>{v.text}</div>
                );
              })}
            </div>
          </div>
          <div className='menu-intro-button'>
            <div className='botton-bg-gradation'></div>
            <div
              className='basic-btn white TO-button-1 pointer'
              onClick={() => {
                changeLang();
              }}
            >
              닫기
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export { PopupLanguageList };
